// extracted by mini-css-extract-plugin
export default {"profile_page":"ProfilePage_profile_page__DqKw+","profile_links":"ProfilePage_profile_links__5VnL7","profile_p":"ProfilePage_profile_p__n2AGc"};